import React from "react";
import { useStore } from "effector-react";
import { Box, Button, makeStyles, Menu, MenuItem, Tooltip, } from "@material-ui/core";
import { KeyboardArrowDown, Translate, Warning } from "@material-ui/icons";
import { $language, languageChanged } from "../model";
import { useTranslation } from "react-i18next";
import { locales } from "../i18n";
var useLanguageSwitchStyles = makeStyles({
    button: {
        color: "white",
    },
});
var languages = {
    ru: "Русский",
    en: "English",
};
export var LanguageSwitcher = function (_a) {
    var _b;
    var _c = _a.showWarning, showWarning = _c === void 0 ? false : _c;
    var t = useTranslation(locales.namespaces.shared).t;
    var userLanguage = useStore($language);
    var classes = useLanguageSwitchStyles();
    var _d = React.useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleMenuItemClick = function (lang) {
        setAnchorEl(null);
        languageChanged(lang);
    };
    return (React.createElement(Box, { display: "flex", justifyContent: "flex-end", alignItems: "center", p: 1, mr: 3 },
        showWarning && (React.createElement(Box, { mr: 1, display: "flex", alignItems: "center" },
            React.createElement(Tooltip, { title: (_b = t("rightholderOnly")) !== null && _b !== void 0 ? _b : "" },
                React.createElement(Warning, null)))),
        React.createElement(Button, { startIcon: React.createElement(Translate, null), endIcon: React.createElement(KeyboardArrowDown, null), className: classes.button, onClick: handleClick }, languages[userLanguage]),
        React.createElement(Menu, { anchorEl: anchorEl, anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "right",
            }, getContentAnchorEl: null, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose }, Object.entries(languages).map(function (_a) {
            var key = _a[0], label = _a[1];
            return (React.createElement(MenuItem, { value: "ru", onClick: function () { return handleMenuItemClick(key); }, selected: key === userLanguage, key: key }, label));
        }))));
};
